import React, { Component } from 'react';
import interaction from '../../../../utils/interaction';
import ProgressBar from '../../shared/progress_bar';

class QuestionGrid extends Component {

  constructor(props){ 
    super(props);
    this.state = {
      selectedAnswers: []
    }

    this.pushSelectedAnswers = this.pushSelectedAnswers.bind(this);
  }
  
  componentDidMount() {
    interaction.animateItems();
    interaction.initSelection();
  } 

  selectAnswer(answer) {
    const selectedAnswers = this.state.selectedAnswers;
    selectedAnswers.push(answer.id);
  }

  pushSelectedAnswers() {
    this.props.next(this.state.selectedAnswers)
  }


  render() {
    const typeClass = this.props.actualQuestion.type === 'multiple' ? 'js-select-checkbox' : 'js-select-radio';
    const typeInput = this.props.actualQuestion.type === 'multiple' ? 'checkbox' : 'radio';
    return (
        <div className="page__container js-select-form">

            <div className="page__top-wrapper">
                <div className="page__text">
                    <h1>{this.props.actualQuestion.title}</h1>
                    <p className="page__desc">{this.props.actualQuestion?.description}</p>
                </div>
                <ProgressBar questions={this.props.questions} actualQuestion={this.props.actualQuestion} type="dark"/>
            </div>

            <ul className="select-images__list">
                {  this.props.actualQuestion.answers.map( answer => (
                    <li onClick={ this.selectAnswer.bind(this, answer) } 
                        key={answer.id}
                        className={`select-images__list-item js-animated-item ${typeClass}`}>
                        <div className="select-images__list-inner">
                            <img className="select-images__list-image" src={answer.image} alt="" />
                            <input className="hidden" type={typeInput} name="item_01" value="blank" />
                        </div>
                        <p className="select-images__list-label">{answer.title}</p>
                        <svg className="select-images__list-icon" width="25" height="25">
                            <use xlinkHref="/images/sprite.svg#done"></use>
                        </svg>
                    </li>
                ))}
            </ul>
            <button 
                onClick={this.pushSelectedAnswers}
                className="page__main-button main-button main-button--colored js-select-submit-button" type="submit">
                <span className="main-button__label">Continuar</span>
                <svg className="main-button__icon" width="25" height="25">
                    <use xlinkHref="/images/sprite.svg#arrow_down"></use>
                </svg>
            </button>
        </div>
    );
  }

}

export default QuestionGrid;
